import { render } from "./tender_subscribes.vue?vue&type=template&id=88d6566e"
import script from "./tender_subscribes.vue?vue&type=script&lang=js"
export * from "./tender_subscribes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/inside/tabs/tender_subscribes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88d6566e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88d6566e', __exports__)) {
    console.log('reload')
    api.reload('88d6566e', __exports__)
  }
  
  module.hot.accept("./tender_subscribes.vue?vue&type=template&id=88d6566e", () => {
    console.log('re-render')
    api.rerender('88d6566e', render)
  })

}


export default __exports__